/** Join class names, dropping falsy values. Small on purpose; no tailwind-merge needed for our kit. */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
